import { IAirport } from '@cai-services';
import { City } from './city.model';
import { Flight } from './flight-input.model';
export class Airport implements IAirport {
  regionCode?: string;
  regionName?: string;
  city?: City;
  timezone: string;
  airportCode: string;
  airportName: string;
  originFlights?: Flight[];
  destFlights?: Flight[];
  cityName?: string;

  constructor(airportCode: string, airportName?: string, timezone?: string) {
    this.airportCode = airportCode;
    this.airportName = airportName;
    this.timezone = timezone;
  }
}
